import DescriptionList from './DescriptionList'
import MetaTagList from './MetaTagList'
import OverlayInfo from './OverlayInfo'
import OverlayTile from './OverlayTile'
import OverlayTileHeading from './OverlayTileHeading'
import ToggleSwitch from './ToggleSwitch'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

export default class OverlayAboutTile extends PureComponent {
  static propTypes = {
    date: PropTypes.string,
    details: PropTypes.object,
    expandableDetails: PropTypes.object,
    heading: PropTypes.string.isRequired,
    metaTags: PropTypes.array,
    searchHighlights: PropTypes.array,
    title: PropTypes.string,
    user: PropTypes.object,
    verb: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.state = {
      detailsExpanded: false
    }
  }

  render() {
    const {
      date,
      details,
      expandableDetails,
      heading,
      metaTags,
      searchHighlights,
      title,
      user,
      verb
    } = this.props
    const { detailsExpanded } = this.state

    return (
      <OverlayTile>
        {expandableDetails && (
          <ToggleSwitch
            className="blueText right"
            expanded={detailsExpanded}
            onClick={() => this.setState({ detailsExpanded: !detailsExpanded })}
          />
        )}
        <OverlayTileHeading icon="info" title={heading} />
        <OverlayInfo
          date={date}
          user={user}
          searchHighlights={searchHighlights}
          title={title}
          verb={verb}
        />
        {metaTags && <MetaTagList metaTags={metaTags} />}
        {details && <DescriptionList listItems={details} />}
        {detailsExpanded && <hr />}
        {detailsExpanded && expandableDetails && (
          <DescriptionList listItems={expandableDetails} />
        )}
      </OverlayTile>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/OverlayAboutTile.js